import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWoning = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="m9 15 11-8 11 8v18H9z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M20 21h-7v12h7z"
    />
    <path
      fill="#00215B"
      d="M16 23.5v-1h6.5V31h-1v-7.5zM16.995 7.622l-10.7 7.782-.59-.808 11.3-8.218L21.3 9.6l-.6.8z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWoning);

export default ForwardRef;
